module.exports = __webpack_public_path__ + "img/umbrella-01.e2fcd911.svg";